import {Notification, Notifications, NotificationsSource} from "@/libwyze-shared/types";
import {OnListItemsListener} from "@/shared/types";
import {BaseApp} from "@/shared/BaseApp";
import {StyledBoxColumn, StyledEmpty, StyledHorizontalDivider, StyledListItem} from "@/shared/StyledComponents";
import {PAGE_FRAGMENT_HALF_WIDTH, PD_SM} from "@/shared/dimens";
import {NotificationsOutlined} from "@mui/icons-material";
import {Button} from "@mui/material";

export class AppNotificationsSource implements NotificationsSource {

  constructor(private readonly notifications: Notifications, private readonly url: string) {
  }

  async init(): Promise<void> {
    await this.notifications.loadListItems();
    this.notifications.notifyAll();
  }

  registerObserver(observer: OnListItemsListener<Notification>): void {
    this.notifications.registerObserver(observer);
  }

  unregisterObserver(observer: OnListItemsListener<Notification>): void {
    this.notifications.unregisterObserver(observer);
  }

  getNotificationsCount(): number {
    return this.notifications.getListItems().filter(notif => notif.isUnread())?.length;
  }

  showPopup(anchorEl: HTMLElement) {
    BaseApp.CONTEXT.showPopover(anchorEl, {anchorOrigin: {horizontal: "center", vertical: "bottom"}}, () => {
      const listItems = this.notifications.getListItems();
      return <StyledBoxColumn
        style={{width: "84dvw", gap: 0, maxWidth: PAGE_FRAGMENT_HALF_WIDTH}}>
        {listItems.length > 0
          ? listItems.map(notif =>
            <StyledListItem
              img={notif.imageUrl}
              icon={NotificationsOutlined}
              title={notif.title}
              text={notif.text}/>)
          : <StyledEmpty emptyConfig={{
            title: "Notifications",
            text: "You are all caught up."
          }}/>}
        <StyledHorizontalDivider/>
        <Button
          style={{padding: PD_SM}}
          onClick={() => BaseApp.CONTEXT.hidePopover()}
          href={this.url}>
          See all
        </Button>
      </StyledBoxColumn>;
    });
  }
}